import { CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';

import { CurrencyCode, MountingOptionView } from '../types';
import { MountingGuide } from './MountingGuide';
import { MountingOption } from './MountingOption';

export interface MountingPickerProps {
  groupName: string;
  options: MountingOptionView[];
  selectedMounting: string | null;
  currencyCode?: CurrencyCode;
  onSelect: (mounting: string) => void;
}

export const MountingPicker = ({
  currencyCode,
  groupName,
  onSelect,
  options,
  selectedMounting,
}: MountingPickerProps) => {
  const { t } = useTranslation('checkout');

  if (options.length <= 1) return null;

  return (
    <fieldset className="grid gap-3">
      <legend className="flex w-full justify-between gap-3">
        <strong>{t('framing.mounting')}</strong>
        <MountingGuide />
      </legend>

      <CheckboxWrapper>
        {options.map((option) => (
          <MountingOption
            key={option.mounting}
            checked={option.mounting === selectedMounting}
            currencyCode={currencyCode}
            groupName={groupName}
            image={option.image}
            mounting={option.mounting}
            onSelect={() => onSelect(option.mounting)}
            priceDelta={option.priceDelta}
          />
        ))}
      </CheckboxWrapper>
    </fieldset>
  );
};
